import { LocaleResource } from './en';

export const pt = {
  main: {
    navbar: {
      home: 'Início',
      customers: 'Clientes',
      about: 'Sobre',
      developers: 'Desenvolvedores',
      language: 'Idioma',
    },
    hero: {
      topBadge: 'Soluções globais de pagamentos',
      header: 'Envie dinheiro para qualquer lugar',
      subHeading:
        'De dólares a euros, passando por pesos e muito mais, a Sphere facilita a movimentação entre moedas como nunca.',
      ctas: {
        primary: 'Para empresas',
        secondary: 'Para indivíduos',
      },
    },
    solutions: {
      header: {
        topBadge: 'Processamento de pagamentos otimizado',
        header: 'Pagamentos sem fronteiras para empresas',
        subHeading:
          'Movimente dinheiro de forma eficiente—de transferências bancárias a cartões, com suporte para todas as principais bandeiras—\ntransferir dinheiro online nunca foi tão simples.',
        ctas: {
          primary: 'Inicie agora',
          secondary: 'Descubra mais',
        },
        cards: {
          '0': {
            title: 'Remessas internacionais',
            description:
              'Envie qualquer moeda, e seus fornecedores recebem USD, MXN, BRL, EUR com taxas de câmbio imbatíveis.',
            bullets: {
              '0': 'Conforme às normas e seguro',
              '1': 'Liquidação quase instantânea',
              '2': 'Cobertura global',
            },
          },
          '1': {
            title: 'Para indivíduos com patrimônio elevado',
            description:
              'Serviços de OTC, conversões entre moeda simplificadas e soluções completas para rastreamento e gestão financeira.',
            bullets: {
              '0': 'Suporte dedicado 24/7',
              '1': 'Alta liquidez',
              '2': 'Privacidade e criptografia',
            },
          },
          '2': {
            title: 'Para Finanças e FinTechs',
            description:
              'Receba pagamentos como quiser, aproveite as conversões automáticas direto na sua conta, e ofereça serviços de conversão personalizados para seus clientes.',
            bullets: {
              '0': 'Acordos de nível de serviço exclusivos',
              '1': 'Proteção ao cliente em primeiro lugar',
              '2': 'API e Soluções No-Code',
            },
          },
        },
      },
    },
    ramp: {
      topBadge: 'Soluções de conversão',
      header: 'Conectando as moedas do mundo',
      subHeading:
        'Deixe a Sphere cuidar das complexidades de engenharia, operações e regulamentações — para que você possa se concentrar no que realmente importa.',
      solutions: {
        '0': {
          title: 'Sob medida para sua marca',
          description:
            'A Sphere gerencia tudo, desde a engenharia até a operação e regulamentação — para que você possa simplesmente desfrutar dos benefícios.',
          bullets: {
            '0': 'Disponível via API, no-code e widget incorporável.',
            '1': 'Ganhe mais tempo economizando horas de desenvolvimento.',
            '2': 'Preço imbatível',
          },
        },
        '1': {
          title: 'Conversão de moedas, fácil e rápido.',
          description:
            'Gere uma carteira vinculada à sua conta bancária. Envie moedas e receba USD com apenas um clique. Disponível para comerciantes selecionados através do painel Sphere.',
        },
        '2': {
          title: 'Compliance integrado',
          description:
            'Conte com nossa expertise global e licenças regulatórias para oferecer a melhor experiência de pagamento aos seus usuários. Deixe que cuidemos do monitoramento de transações, triagem de sanções e detecção de fraudes para você.',
        },
      },
    },
    dashboard: {
      topBadge: 'Funcionalidades',
      header: 'Painel Sphere',
      subHeading:
        'Os links de pagamento Sphere são versáteis, personalizáveis e robustos. Eles se adaptam às suas necessidades, seja para compras únicas ou assinaturas recorrentes.',
      solutions: {
        '0': {
          title: 'Links de pagamento',
          description:
            'Aceite pagamentos diretamente por e-mail, SMS, redes sociais, site ou app. Aproveite todo o poder da Sphere sem precisar escrever uma única linha de código.',
        },
        '1': {
          title: 'Assinaturas',
          description:
            'Ofereça assinaturas tradicionais ou autênticas on-chain — diretamente do cartão, conta bancária ou carteira digital. Faturamento flexível, desde por minuto até anual, medido por assento, e de volume a níveis graduados. Receba pagamentos diretamente, sem intermediários, desbloqueio de tokens, relayers de gas ou outros passos desnecessários.',
        },
        '2': {
          title: 'Ferramentas de desenvolvimento',
          description:
            'A Sphere simplifica o seu processo de engenharia com funcionalidades de pagamento integradas. Nós lidamos com as complexidades econômicas globais, permitindo que suas equipes foquem no desenvolvimento eficiente em uma plataforma unificada.',
        },
        '3': {
          title: 'Análises e insights de clientes',
          description:
            'Acompanhe mais de 15 KPIs, como MRR, churn, taxas de conversão e cliques. Maximize seus ganhos, aumente as taxas de aprovação, receba pagamentos mais rapidamente e reduza estornos aceitando uma maior variedade de pagamentos.',
        },
      },
    },
    developerTools: {
      topBadge: 'SDK',
      header: 'Kit de ferramentas para devs',
      subHeading:
        'Seguimos as melhores práticas em pagamentos para oferecer SDKs semânticos e fáceis de usar. Concentre-se no crescimento do seu negócio enquanto cuidamos das auditorias de contratos inteligentes, orquestração cross-chain e toda a manutenção técnica, operacional e de conformidade.',
      bullets: {
        '0': 'API RESTful simples, poderosa e intuitiva',
        '1': 'Código pronto para copiar-e-colar',
        '2': 'Documentação clara e completa',
      },
      ctas: {
        primary: 'Documentação',
        secondary: 'Suporte ao dev',
      },
    },
    features: {
      header: {
        topBadge: 'Funcionalidades',
        title: 'Uma suíte de pagamentos completa',
        description:
          'Conecte-se perfeitamente através de uma única API ou um console fácil de usar em minutos.\nAcesse conformidade de alto nível, contabilidade, pagamentos, on/off-ramps, análises e ferramentas para desenvolvedores — tudo em um só lugar.',
      },
      grid: {
        '0': 'Análises completas',
        '1': 'Pagamentos e recebimentos multipartes',
        '2': 'Construção colaborativa com ACLs baseados em funções',
        '3': 'Detecção avançada de AML e fraude',
        '4': 'Segurança certificada',
        '5': 'Notificações por email',
      },
      securityMarquees: {
        '0': 'Sanções\nOFAC',
        '1': 'Práticas de segurança de FTC',
        '2': 'Práticas de segurança de GDPR',
        '3': 'Compatível com\nPCI',
      },
      benefits: {
        lowestFees: {
          title: 'Menores taxas do mercado',
          description:
            'Todas as transações com taxas equiparadas às da concorrência, com taxas de rede repassadas ao custo.',
        },
        convenientSwaps: {
          title: 'Swaps convenientes',
          description:
            'Pagamentos diretamente na sua conta bancária ou na de um fornecedor terceirizado, de forma manual ou agendada, com taxas competitivas de nível OTC.',
        },
        instantSettlements: {
          title: 'Liquidações instantâneas',
          description:
            'Receba seu dinheiro em segundos ou minutos, em vez de dias ou semanas.',
        },
        splitPayouts: {
          title: 'Pagamentos divididos',
          description:
            'Divida os pagamentos automaticamente sem taxas adicionais.',
        },
        nonCustodial: {
          title: 'Não custodial',
          description:
            'Os pagamentos são ponto a ponto e nunca manipulamos fundos de clientes ou comerciantes.',
        },
        audited: {
          title: 'Auditado',
          description:
            'Nossos contratos são auditados pelos melhores especialistas do setor. Regularmente realizamos modelagem de ameaças, testes de penetração e avaliações de vulnerabilidades em nossa infraestrutura.',
        },
        compliant: {
          title: 'Compliance',
          description:
            'A Sphere segue todas as melhores práticas de acordo com as regulamentações dos EUA e utiliza transmissores de dinheiro licenciados.',
        },
        encrypted: {
          title: 'Criptografado',
          description:
            'Todos os dados são criptografados e/ou tokenizados em repouso e em trânsito. Nunca armazenamos PII sensível e temos ACLs rígidos.',
        },
      },
    },
    ctaSection: {
      header: 'Pronto para dar o próximo passo?',
      description:
        'Venha fazer parte dos líderes da indústria que já estão crescendo com a Sphere.',
      button: 'Começar',
    },
    faq: {
      header: 'FAQ',
      description:
        'Perguntas frequentes. Não encontrou a resposta que procurava? Entre em contato.',
      questions: {
        '0': {
          q: 'Quanto custa para usar a Sphere?',
          a: 'O acesso ao software é gratuito, mas cobramos uma pequena taxa por transação. Preços personalizados para empresas estão disponíveis mediante solicitação.',
        },
        '1': {
          q: 'Quais redes são suportadas?',
          a: 'Suportamos todas as principais redes de cartões (Visa, Mastercard, American Express, Discover) em mais de 120 países, transferências bancárias e transferências nacionais e internacionais.',
        },
        '2': {
          q: 'Como é realizada a conversão de moedas?',
          a: 'Os clientes consentem em trocar para uma moeda diferente durante a transferência, que é roteada por meio de uma exchange ou sujeita a taxas de câmbio ao custo.',
        },
        '3': {
          q: 'A Sphere é auditada?',
          a: 'Sim, somos auditados pela OtterSec e estamos em conformidade com PCI-DSS. Voluntariamente atendemos aos requisitos de MSB/VASP e implementamos um robusto programa de KYC/AML. Estamos em processo de obter as certificações SOC2 e ISO/IEC 27001.',
        },
        '4': {
          q: 'A Sphere faz custódia de fundos?',
          a: 'Nunca. Somos um provedor de serviços tecnológicos, não um MSB/VASP nem um transmissor de dinheiro. Todos os pagamentos que envolvem custódia são tratados por transmissores de dinheiro licenciados, custodianos qualificados e bancos autorizados.',
        },
        '5': {
          q: 'É possível integrar a Sphere com minha solução de pagamento existente?',
          a: 'Sim. Você pode usar seu próprio Stripe ou outros provedores de pagamento e usar a Sphere para adicionar suporte a pagamentos alternativos e automação de back-office por meio de nossa API/SDK. Projetamos nossa API para utilizar fluxos de dados e modelos de objetos semelhantes, reduzindo a quantidade de infraestrutura a ser reescrita.',
        },
      },
    },
    footer: {
      slogan:
        'De dólares e euros a pesos e muito mais, o Sphere facilita a movimentação entre moedas.',
      termsOfService: 'Termos de Serviço & Política de Privacidade',
      privacyPolicy: 'Política de Privacidade',
      reportVulnerability: 'Reportar uma vulnerabilidade',
    },
  },
  accessRequest: {
    steps: {
      '1': {
        title: 'Solicitar Acesso',
        descriptionParagraph1:
          'Para <0>indivíduos</0> que desejam utilizar nossa funcionalidade de on- e off- ramping, agora é possível fazer isso sem precisar nos contatar. <0>Basta visitar</0> <1>spherepay.co/ramp</1> para se registrar e começar.',
        descriptionParagraph2:
          'Para empresas ou outras solicitações, por favor, complete as informações abaixo e um especialista da Sphere entrará em contato em breve.',
        form: {
          walletAddress: 'Endereço da Carteira',
          firstName: 'Nome',
          lastName: 'Sobrenome',
          email: 'Email de Trabalho',
          businessName: 'Nome da Empresa',
          businessUrl: 'URL do Site da Empresa',
          phoneNumber: 'Número de Telefone',
        },
        notYourEmail: 'Não é seu email?',
        errors: {
          emailAlreadyInUse:
            'Este email já está em uso para uma solicitação ativa. Por favor, tente outro.',
          emailAlreadyLinkedToAccount:
            'Este email já está vinculado a uma conta. Prefere iniciar sessão?',
        },
      },
      '2': {
        title: 'Informações de Contato',
        form: {
          preferredContactMethod: 'Método de Contato Preferido',
          preferredContactMethodDescription:
            'Os detalhes de acesso à conta serão enviados por e-mail.',
          placeholders: {
            telegram: '@nomedeusuario',
            whatsapp: '+1234567890',
            email: 'voce@exemplo.com',
            sms: '+1234567890',
          },
        },
      },
      '3': {
        title: 'Detalhes do Negócio',
        form: {
          bankAccountJurisdiction:
            'Seu negócio possui uma conta bancária em algum dos seguintes países?',
          bankAccountJurisdictionsOptions: {
            unitedStates: 'Estados Unidos (USD)',
            europeanUnion: 'União Europeia (EUR)',
            noneOfTheAbove: 'Nenhuma das opções acima',
          },
          preferredCurrencies:
            'Quais moedas você gostaria de usar para transações de on- e off- ramping?',
          preferredCurrenciesDescription:
            'Por favor, selecione pelo menos uma.',
          otherCurrencyPlaceholder: 'Por favor, especifique',
        },
      },
      '4': {
        title: 'Detalhes do Negócio',
        submitApplication: 'Enviar solicitação',
        form: {
          businessOperatingAddress: 'Endereço Operacional do Negócio',
          businessCountry: 'Em qual país seu negócio está localizado?',
          countryPlaceholder: 'País',
          statePlaceholder: 'Estado',
          monthlyTransferVolume: 'Volume de Transferência Mensal',
          estimatedTransactionVolume:
            'Qual foi o volume estimado de transações no mês passado?',
          selectPlaceholder: 'Por favor, selecione',
          monthlyVolume: {
            '0_4999': 'Menos de $4.999',
            '5000_9999': '$5.000 - $9.999',
            '10000_99999': '$10.000 - $99.999',
            '100000_499999': '$100.000 - $499.999',
            '500000_999999': '$500.000 - $999.999',
            '1000000_5000000': '$1.000.000 - $5.000.000',
            '5000000_plus': 'Mais de $5.000.000',
          },
          additionalDetails: 'Detalhes Adicionais',
          additionalDetailsDescription:
            'Descreva a natureza do negócio e seus objetivos para a conta.',
        },
      },
    },
    submitted: {
      title: 'Seu cadastro foi\nenviado com sucesso',
      defaultBody:
        'Obrigado pelo seu interesse. Nossa equipe revisará suas informações e entrará em contato <0>por email</0> se pudermos conceder acesso a uma conta.',
      bridgeBody:
        'Obrigado pelo seu interesse. Nossa equipe revisará suas informações e entrará em contato <0>por email</0> quando pudermos atendê-lo.',
      conciergeBody:
        'Ótimo! Alguém da nossa equipe entrará em contato em breve. Se houver qualquer atraso, sinta-se à vontade para nos contatar diretamente aqui:',
      returnToWebsite: 'Voltar ao site',
      contactUs: 'Conectar com seu especialista de onboarding',
    },
    googleSplash: {
      pendingTitle: 'Sua conta ainda está\npendente de aprovação',
      noAccountTitle: 'Este Gmail não está associado\na uma conta Sphere',
      applicationId: 'Seu ID de Aplicação:',
      pendingDescription:
        'Recebemos sua solicitação Sphere e estamos processando seu pedido. Entraremos em contato em breve com uma atualização sobre o status da sua conta o mais rápido possível.',
      noAccountDescription:
        'Este Gmail não está vinculado a uma conta Sphere.\nPreencha uma solicitação para começar.',
      returnToLogin: 'Voltar ao login',
      fillOutApplication: 'Preencher solicitação',
    },
    loadingAnimation: {
      calculatingRates: 'Calculando as melhores taxas de câmbio...',
      securingTransactions: 'Protegendo suas transações...',
      optimizingPayments: 'Otimizando pagamentos globais...',
      connectingCurrencies: 'Conectando moedas...',
      ensuringCompliance: 'Garantindo padrões de conformidade...',
      processingData: 'Processando dados com segurança...',
      almostThere: 'Quase lá...',
    },
    passwordSetup: {
      loginSuccess: 'Login bem-sucedido! Bem-vindo de volta {{email}}',
      newLinkSent: 'Um novo link foi enviado para o seu e-mail.',
      regenerateError:
        'Ocorreu um erro ao regenerar o token de acesso. Por favor, tente novamente.',
      tokenNotFoundOrInvalid: 'Token não encontrado ou inválido',
      tokenNotFoundOrInvalidDescription:
        'O token de acesso que você está tentando usar não foi encontrado ou é inválido. Isso pode ser devido à expiração ou a um erro no link.',
      returnToWebsite: 'Voltar ao site',
      contactSupport: 'Contatar suporte',
      linkExpired: 'Seu link expirou',
      linkExpiredDescription:
        'O link do e-mail expirou. Por favor, gere um novo para completar seu cadastro.',
      redirecting_zero: 'Redirecionando você agora...',
      redirecting_one: 'Redirecionando você em 1 segundo...',
      redirecting_other: 'Redirecionando você em {{count}} segundos...',
      regenerateLink: 'Regenerar Link',
      createSignIn: 'Criar Login',
      createAccount: 'Criar conta',
      email: 'E-mail',
      password: 'Senha',
      enterPassword: 'Digite a Senha',
      confirmPassword: 'Confirme a Senha',
    },
  },
  validation: {
    required: 'Obrigatório',
    invalidEmail: 'Por favor, insira um e-mail válido',
    emailTooLong: 'Máximo: 255 caracteres',
    firstNameTooLong: 'Máximo: 50 caracteres',
    lastNameTooLong: 'Máximo: 50 caracteres',
    businessNameTooLong: 'Máximo: 50 caracteres',
    businessUrlTooLong: 'Máximo: 255 caracteres',
    phoneNumberTooLong: 'Máximo: 20 caracteres',
    phoneNumberInvalid:
      'Por favor, introduza um número de telefone válido em formato internacional (ex., +1234567890)',
    preferredContactMethodValueTooLong: 'Máximo: 255 caracteres',
    weakPassword:
      'A senha deve ter pelo menos 6 caracteres e conter pelo menos uma letra e um número',
    passwordsDoNotMatch: 'As senhas não coincidem',
  },
  general: {
    comingSoon: 'Em breve',
    support: 'Suporte',
    optional: 'Opcional',
    back: 'Voltar',
    next: 'Próximo',
    continue: 'Continuar',
    yes: 'Sim',
    no: 'Não',
    other: 'Outro',
    selectAllThatApply: 'Selecione todos que se aplicam',
    unknownError:
      'Ocorreu um erro desconhecido. Por favor, tente novamente mais tarde.',
  },
  // ramp-widget translations
  translations: {
    validation: {
      required: 'Obrigatório',
      email: 'Email inválido',
      passwordsMatch: 'As senhas não coincidem',
      invalidCountry: 'País inválido',
      invalidState: 'Estado inválido',
      invalidIban: 'IBAN inválido',
      invalidWalletAddress: 'Endereço de carteira inválido',
      positive: 'Digite um número positivo',
      maxLength: {
        wireMessage:
          'Mensagem de transferência deve ter menos de 105 caracteres',
      },
      invalidSortCode:
        'O número de rota deve estar no formato XX-XX-XX ou XXXXXX',
      invalidAccountNumber: 'Número de conta inválido',
      phoneNumberInvalid:
        'Por favor, introduza um número de telefone válido em formato internacional (ex., +1234567890)',
    },
    sidebar: {
      createPayout: 'Criar transferência',
      withdrawToBank: 'Sacar para o banco',
      depositToWallet: 'Depositar na carteira',
      myAccounts: 'Minhas contas',
      accounts: 'Contas',
      payoutHistory: 'Minhas transferências',
      history: 'Transferências',
      settings: 'Configuração',
      offRamp: 'Sacar para o banco',
      onRamp: 'Depositar na carteira',
    },
    signIn: {
      title: 'Bem-vindo',
      description: 'Faça login na sua conta',
      form: {
        email: 'Email',
        emailPlaceholder: 'Digite seu email',
        password: 'Senha',
        cta: 'Entrar',
      },
      or: 'ou',
      signInWith: 'Entrar com {{provider}}',
      footer: {
        text: 'Não tem uma conta?',
        cta: 'Crie uma',
      },
      error: {
        title: 'Algo deu errado',
        text: 'Nenhum usuário foi encontrado com essa combinação de email e senha. Se o problema persistir, por favor, entre em contato com o suporte.',
      },
      operatingResidency: {
        title: 'Quase lá',
        description:
          'Precisamos só de mais alguns detalhes antes de conectar-te...',
        form: {
          label: 'Residencia operativa',
          countryPlaceholder: 'Selecione um país',
        },
        error: {
          title: 'Região não suportada no momento',
          text: 'Obrigado pelo seu interesse em usar {{merchantName}}. Infelizmente, devido a restrições regulatórias, não podemos cadastrar clientes do seu país/estado no momento. Entendemos que isso pode ser decepcionante e pedimos desculpas por qualquer inconveniência que isso possa causar.<br /><br />Se houver alguma mudança nessas regulamentações no futuro, teremos prazer em reconsiderar sua inscrição. Agradecemos sua compreensão.',
        },
        info: {
          title: 'Importante',
          text: 'Uma conta bancária americana ou europeia é necessária para processar transações, independentemente de onde você reside ou opera seu negócio.',
        },
      },
      otp: {
        title: 'Verifique seu email',
        description: {
          line1: 'Enviamos um link de verificação para {{email}}.',
          line2: 'Verifique sua caixa de entrada para os próximos passos.',
        },
        cta: 'Continuar',
        footer: {
          text: 'Não recebeu o email?',
          cta: 'Reenviar',
        },
        error: {
          invalid: {
            title: 'Código inválido',
            text: 'O código digitado não é mais válido. Por favor, solicite um novo código.',
            buttons: {
              backToSignIn: 'Voltar para o login',
              resend: 'Reenviar',
            },
          },
          mismatch: {
            title: 'Código incorreto',
            text: 'O código digitado está incorreto. Por favor, tente novamente.',
          },
        },
      },
    },
    signUp: {
      title: 'Você foi convidado',
      description:
        'Confirmamos seu email, agora crie uma senha para completar a configuração da sua conta.',
      form: {
        email: 'Email',
        createAPassword: 'Criar uma senha',
        enterPassword: 'Digite a senha',
        confirmPassword: 'Confirme a senha',
        cta: 'Criar conta',
      },
    },
    onboarding: {
      title: 'Comece agora',
      description:
        'Comece a transferir entre USD e cripto em poucos passos simples.',
      steps: {
        tos: {
          title: 'Termos de serviço',
          description:
            'Este aplicativo usa Sphere e outros terceiros para mover fundos de forma segura.',
        },
        connectBank: {
          title: 'Conectar banco',
          description: 'Verifique seu banco manualmente.',
          tooltipWhenDisabled:
            'Conclua as etapas anteriores para conectar seu banco',
        },
        kyc: {
          title: 'Verificar identidade',
          description:
            'A verificação KYC é o processo obrigatório de identificar e verificar a identidade.',
          tooltipWhenDisabled:
            'Você deve aceitar os Termos de Serviço primeiro',
          customerType: {
            individual: {
              title: 'Verifique como indivíduo',
              description:
                'O tempo médio de identificação do cliente varia de 1 a 30 minutos.',
            },
            business: {
              title: 'Verifique uma empresa',
              description:
                'O tempo médio de verificação comercial varia de 3 a 5 dias úteis.',
            },
            continue: 'Continuar',
          },
          alert: {
            description:
              'O próximo passo é a verificação. A verificação pode levar até 3 dias para casos que requerem revisão manual, mas geralmente é mais rápida. Após você enviar suas informações, informaremos quando você poderá retornar para seguir para o próximo passo.',
          },
        },
        msa: {
          title: 'Verifique seu email',
          description:
            'Enviamos um link de verificação do MSA para {{email}}. Assine o documento e prossiga para o próximo passo.',
          cta: 'Assinar MSA',
          resendEmailCta: 'Reenviar Email',
          emailSent: 'Email Enviado!',
          pendingSignatureBadge: 'Aguardando assinatura',
        },
      },
      badge: {
        pending: 'Pendente',
        complete: 'Completo',
        underReview: 'Em revisão',
        softRejected: 'Ação necessária',
        rejected: 'Rejeitado',
        error: 'Erro',
        tooltips: {
          underReviewBySumsub:
            'Estamos atualmente revisando sua submissão através de nosso provedor terceirizado. Isso geralmente leva uma hora, mas às vezes pode levar até 3 dias para casos que requerem revisão manual. Se você enfrentar atrasos prolongados além disso, por favor, entre em contato com o suporte.',
          underReviewByBridge:
            'Você foi verificado com sucesso pelo nosso provedor terceirizado. Por favor, aguarde enquanto finalizamos o processo. Verifique mais tarde ou espere até receber um e-mail sobre seu status dentro de 1-3 dias úteis. Se você enfrentar atrasos prolongados além disso, por favor, entre em contato com o suporte.',
        },
      },
      cta: {
        start: 'Começar',
        continue: 'Continuar',
        incomplete: 'Iniciar',
        pending: 'Em revisão',
        softRejected: 'Corrigir',
        rejected: 'Contatar suporte',
        error: 'Tentar novamente',
        getStarted: 'Começar',
        next: 'Continuar',
        checkStatus: 'Verificar status',
        tooltips: {
          contactSupport:
            'Infelizmente, não conseguimos finalizar sua verificação com nossos sistemas internos. Se você acredita que isso seja um erro, entre em contato com o suporte para assistência.',
        },
      },
      failedToVerify: {
        title: 'Falha ao verificar sua conta',
        description:
          'Obrigado por sua interesse em usar RAMP. Infelizmente, devido às nossas políticas de conformidade, não podemos proceder com o registro de sua conta neste momento. Entendemos que isso pode ser desapontador e discutimos com desculpa qualquer inconveniente que isso possa causar. Se você acredita que essa decisão foi um erro, entre em contato com nosso time em <0>compliance@spherepay.co</0>.',
        cta: 'Sair',
        badge: 'Falhou',
      },
    },
    myAccounts: {
      title: 'Minhas Contas',
      bank: {
        tabTitle: 'Minhas Contas Bancárias',
        action: 'Conectar conta bancária',
        empty: {
          title: 'Nenhuma conta bancária',
          description: 'Conecte suas contas bancárias para começar.',
          action: 'Conectar banco',
        },
        table: {
          header: {
            bankName: 'Banco',
            bankNameAccountType: {
              checking: 'Corrente',
              savings: 'Poupança',
              instapay: 'Instapay',
              pesonet: 'Pesonet',
            },
            last4: 'Últimos 4',
            routingNumber: 'Nº do banco',
            status: 'Status',
            linkedWallets: 'Carteiras Vinculadas',
            actions: 'Ações',
          },
          actions: {
            delete: {
              label: 'Deletar',
              dialog: {
                title: 'Deletar conta bancária',
                description:
                  'Você tem certeza que deseja deletar esta conta bancária?',
              },
              cta: 'Deletar conta bancária',
            },
          },
          tooltips: {
            deletedAt: 'Você deletou esta conta {{date}}',
          },
        },
        form: {
          title: 'Adicionar Nova Conta Bancária',
          plaidAlert: {
            title: 'Atenção',
            description:
              'Se você planeja iniciar transferências entre cartões e contas bancárias, <i>ou</i> realizar transferências on-ramp automáticas, seu banco <strong>deve</strong> ser conectado via Plaid.',
          },
          plaidButton: 'Conectar com Plaid',
          accountOwner: 'Proprietário da conta',
          accountOwnerType: {
            personal: 'Pessoal',
            third_party: 'Terceiros',
          },
          bankType: 'Tipo de banco',
          currency: 'Moeda',
          bankName: 'Nome do banco',
          bankNamePlaceholder: 'Comece a digitar...',
          bankNamePlaceholderNoCustomName: 'Selecione o banco...',
          noBankFound: 'Pressione Enter para selecionar {{name}}',
          accountType: 'Tipo de conta',
          accountHolder: 'Titular da conta',
          accountHolderName: 'Nome do titular da conta',
          accountHolderFirstName: 'Nome',
          accountHolderLastName: 'Sobrenome',
          accountHolderBirthDate: 'Data de nascimento',
          business: 'Empresa',
          businessName: 'Nome',
          businessDBAName: 'Nome comercial (se aplicável)',
          businessType: 'Tipo',
          businessTaxId: 'Número de identificação fiscal',
          businessWebsite: 'Site',
          businessRegistrationNumber: 'Número de registro',
          businessCardType: {
            soleProprietorship: 'Empresário Individual',
            partnership: 'Sociedade',
            llc: 'Sociedade Limitada',
            corporation: 'Corporação',
            cooperative: 'Cooperativa',
            trust: 'Fideicomisso',
          },
          phone: 'Telefone',
          email: 'E-mail',
          routingNumber: 'Número do banco',
          accountNumber: 'Número da conta',
          bic: 'Código BIC',
          iban: 'IBAN',
          clabe: 'Número CLABE',
          pixKey: 'Chave PIX',
          taxID: 'ID Fiscal',
          channelSubject: 'Categoria de Pagamento',
          ifsc: 'Código IFSC',
          bankDocumentNumber: 'Número de documento do banco',
          bankID: 'Código do Banco',
          sortCode: 'Código de orden',
          branchCode: 'Código de sucursal',
          branchCodeHelpText:
            'Formato combinado de Número de Instituição (3 dígitos) e Número de Trânsito (5 dígitos).',
          nickname: 'Apelido',
          nicknameDescription: 'Opcional.',
          beneficiaryAddress: {
            main: 'Endereço do beneficiário',
            country: 'País',
            countryPlaceholder: 'Selecione um país',
            addressLine1: 'Linha de endereço 1',
            addressLine2: 'Linha de endereço 2',
            city: 'Cidade',
            state: 'Estado',
            statePlaceholders: {
              default: 'Selecione um estado',
              noCountrySelected: 'Selecione um país primeiro',
              empty: 'Nenhum estado encontrado',
            },
            postalCode: 'CEP',
          },
          cta: 'Adicionar conta',
          success: {
            title: 'Conta bancária adicionada',
            description: 'Sua conta bancária foi adicionada.',
          },
          error: {
            title: 'Algo deu errado',
            description:
              'Não conseguimos adicionar sua conta bancária neste momento. ({{error}})',
          },
          verificationPending: {
            title: 'Verificação Pendente',
            description:
              'Estamos verificando sua conta. Este processo pode levar até 24 horas. Você receberá um e-mail quando a verificação estiver completa.',
            cta: 'Contatar Suporte',
          },
        },
        offloaderWallets: {
          form: {
            networkDropdown: {
              label: 'Selecione uma rede:',
              placeholder: 'Selecione uma rede:',
            },
            stablecoinDropdown: {
              label: 'Selecione um token:',
              placeholder: 'Selecione um token:',
            },
            transferMethodDropdown: {
              label: 'Selecione um método de transferência:',
              placeholder: 'Selecione um método de transferência:',
            },
          },
          table: {
            actions: {
              generateWalletAddress: 'Gerar endereço de carteira',
            },
            cell: {
              viewWallets: 'Ver carteiras',
            },
          },
          modal: {
            toast: {
              success: 'Carteira Offloader criada com sucesso',
              error: 'Algo deu errado com a criação da carteira do offloader',
            },
            title: 'Gerar endereço de carteira',
            description:
              'Selecione o blockchain para gerar seu novo endereço de carteira. Este endereço pode ser usado para receber e enviar fundos com outros endereços na mesma rede.',
            button: {
              confirm: 'Confirmar',
              cancel: 'Cancelar',
              close: 'Fechar',
            },
            linkedWallets: {
              title: 'Carteiras Vinculadas',
              description:
                'Abaixo estão as carteiras associadas à sua conta bancária. Você pode usar esses endereços para receber fundos nos respectivos blockchains.',
              addressHeader: 'Endereços de saída:',
            },
          },
        },
      },
      wallet: {
        tabTitle: 'Carteiras',
        actions: {
          primary: 'Conectar carteira',
          secondary: 'Entrar manualmente',
        },
        empty: {
          title: 'Nenhuma carteira',
          description: 'Conecte suas carteiras para começar.',
          action: 'Conectar carteira',
        },
        connection: {
          selector: {
            trigger: 'Conectar carteira',
            title: 'Conecte uma carteira Solana para continuer',
            installedDescription: 'Detectada',
            moreOptions: 'Mais opções',
          },
        },
        form: {
          title: 'Adicionar Carteira {{networkName}}',
          description: {
            line1:
              'Enviar cripto pela rede errada pode significar a perda de seus fundos.',
            line2:
              'Certifique-se de escolher a rede correta. Em caso de dúvida, envie uma quantia pequena.',
          },
          nickname: 'Apelido',
          nicknamePlaceholder: 'Ex., Carteira Sphere',
          nicknameDescription: 'Máximo de 20 caracteres.',
          address: 'Endereço',
          consent: {
            label: 'Confirmo que as informações acima estão corretas.',
            description:
              'Enviar cripto pela rede errada pode significar a perda de seus fundos.',
          },
          cta: 'Adicionar carteira',
          success: {
            title: 'Carteira adicionada',
            description: 'Sua carteira foi adicionada.',
          },
          error: {
            title: 'Algo deu errado',
            description:
              'Não conseguimos adicionar sua carteira neste momento. ({{error}})',
          },
        },
        editForm: {
          title: 'Editar Carteira',
          cta: 'Salvar',
          success: {
            title: 'Carteira atualizada',
            description: 'Sua carteira foi atualizada.',
          },
          error: {
            title: 'Algo deu errado',
            description:
              'Não conseguimos atualizar sua carteira neste momento. ({{error}})',
          },
          deleteCta: 'Deletar',
          deleteDialog: {
            title: 'Deletar carteira',
            description: 'Você tem certeza que deseja deletar esta carteira?',
          },
          deleteSuccess: {
            title: 'Carteira deletada',
            description: 'Sua carteira foi deletada.',
          },
          deleteError: {
            title: 'Algo deu errado',
            description:
              'Não conseguimos deletar sua carteira neste momento. ({{error}})',
          },
        },
        items: {
          actions: {
            edit: 'Editar',
            copyAddress: 'Copiar endereço',
            copy: 'Copiar',
          },
        },
      },
      card: {
        tabTitle: 'Cartões',
        action: 'Conectar cartão',
        empty: {
          title: 'Nenhum cartão',
          description: 'Conecte seus cartões para começar.',
          action: 'Conectar cartão',
        },
      },
      thirdParty: {
        tabTitle: 'Contas de Terceiros',
        action: 'Conectar conta de terceiro',
        table: {
          header: {
            currency: 'Moeda',
          },
          actions: {
            delete: {
              label: 'Deletar',
              dialog: {
                title: 'Deletar conta bancária',
                description:
                  'Você tem certeza que deseja deletar esta conta bancária?',
              },
              cta: 'Deletar conta bancária',
            },
            details: {
              label: 'Ver detalhes',
              dialog: {
                title: 'Detalhes da conta bancária',
                description: 'Ver os detalhes da conta bancária de terceiro.',
              },
              cta: 'Ver detalhes',
            },
          },
        },
        empty: {
          title: 'Nenhuma conta de terceiro',
          description: 'Conecte suas contas de terceiro para começar.',
          action: 'Conectar conta de terceiro',
        },
      },
    },
    createPayout: {
      title: 'Criar Transferência',
      description: 'Selecione seu método de transferência abaixo.',
      onRamp: {
        card: {
          title: 'On-ramp para uma carteira digital',
          description: 'Converta dinheiro em moedas digitais.',
        },
        title: 'On-ramp',
        currencies: {
          title: 'Selecione uma moeda',
          placeholder: 'Buscar...',
          options: {
            usd: {
              label: 'USD',
              description: 'Dólar americano',
            },
            eur: {
              label: 'EUR',
              description: 'Euro',
            },
            brl: {
              label: 'BRL',
              description: 'Real brasileiro',
            },
            mxn: {
              label: 'MXN',
              description: 'Peso mexicano',
            },
            php: {
              label: 'PHP',
              description: 'Peso filipino',
            },
            inr: {
              label: 'INR',
              description: 'Rupia indiana',
            },
          },
          verificationPending: {
            title: 'Verificação Pendente',
            description:
              'Estamos verificando sua conta. Por isso, você não tem acesso a nenhuma das nossas moedas suportadas neste momento.',
            cta: 'Contatar Suporte',
          },
        },
        methods: {
          title: 'Selecione um método de transferência',
          options: {
            usd: {
              ach: {
                title: 'ACH',
                subtitle: 'Transferência de conta bancária nos EUA',
                description: 'On-ramp dólares de uma conta bancária americana.',
                badges: {
                  recommended: 'Recomendado',
                  domestic: 'Nacional',
                  businessDays01: '0-1 Dias',
                  noFees: '0 Taxas',
                },
              },
              swift: {
                title: 'SWIFT',
                subtitle: 'Transferência internacional para conta em USD',
                description: 'Ideal para transferências internacionais.',
                badges: {
                  comingSoon: 'Em breve',
                  international: 'Internacional',
                  businessDays05: '0-5 Dias',
                },
              },
              wire: {
                title: 'Wire',
                subtitle: 'Transferência para conta em USD',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 Dias',
                  domestic: 'Nacional',
                  businessDays01: '0-1 Dias',
                },
              },
            },
            eur: {
              sepa: {
                title: 'SEPA',
                subtitle: 'Transferência de conta bancária em EUR',
                description: 'On-ramp euros de uma conta bancária europeia.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: '0 Taxas',
                },
              },
              swift: {
                title: 'SWIFT',
                subtitle: 'Transferência internacional para conta em EUR',
                description: 'Ideal para transferências internacionais.',
                badges: {
                  comingSoon: 'Em breve',
                  international: 'Internacional',
                  businessDays05: '0-5 Dias',
                },
              },
              wire: {
                title: 'Wire',
                subtitle: 'Transferência para conta em EUR',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 Dias',
                  domestic: 'Nacional',
                  businessDays01: '0-1 Dias',
                },
              },
            },
            mxn: {
              clabe: {
                title: 'CLABE',
                subtitle: 'Transferência de conta bancária no MX',
                description:
                  'On-ramp pesos mexicanos de uma conta bancária mexicana.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: '0 Taxas',
                },
              },
              wire: {
                title: 'Wire',
                subtitle: 'Transferência para conta bancária MX',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 dias',
                },
              },
            },
            brl: {
              pix: {
                title: 'PIX',
                subtitle: 'Transferência de conta bancária no BR',
                description: 'On-ramp reais de uma conta bancária brasileira.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: '0 Taxas',
                },
              },
              wire: {
                title: 'Wire',
                subtitle: 'Transferência para conta bancária BR',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 dias',
                },
              },
            },
            php: {
              instapay: {
                title: 'Instapay',
                subtitle: 'Transferência de conta bancária nas PH',
                description:
                  'On-ramp pesos filipinos de uma conta bancária filipina.',
                badges: {
                  amountsSmallerThan500000: 'Montos menores a 500,000 PHP',
                },
              },
              swiftpay_pesonet: {
                title: 'Swiftpay PesoNet',
                subtitle: 'Transferência para conta bancária PH',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  amountsBiggerOrEqualThan500000:
                    'Montos maiores ou iguais a 500,000 PHP',
                },
              },
            },
            inr: {
              neft: {
                title: 'NEFT',
                subtitle: 'Transferência de conta bancária na IN',
                description: 'On-ramp rupias de uma conta bancária indiana.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: '0 Taxas',
                },
              },
              wire: {
                title: 'Wire',
                subtitle: 'Transferência para conta bancária INR',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 dias',
                },
              },
            },
          },
        },
        manualTransferAlert: {
          title: 'O processo de on-ramp na Sphere é manual.',
          description:
            'Para adicionar fundos, você vai precisar transferir dinheiro da sua conta bancária para a Sphere usando os dados que vamos te mostrar na próxima etapa. Nós te notificaremos por e-mail assim que a transferência for concluída.',
        },
        blocked: {
          title: 'On-ramping bloqueado',
          description:
            'Você não está autorizado a on-ramp qualquer moeda. Por favor, entre em contato com o suporte se precisar de assistência.',
          cta: 'Contatar Suporte',
        },
      },
      pushToCard: {
        card: {
          title: 'On-ramp para um cartão de débito',
          description:
            'Envie dinheiro do seu banco para o seu cartão de débito.',
        },
      },
      offRamp: {
        title: 'Off-ramp',
        card: {
          title: 'Off-ramp para uma conta bancária',
          description: 'Converta moedas digitais em uma conta bancária.',
        },
        currencies: {
          title: 'Selecione uma moeda',
          placeholder: 'Buscar...',
          options: {
            usd: {
              label: 'USD',
              description: 'Dólar americano',
            },
            eur: {
              label: 'EUR',
              description: 'Euro',
            },
            mxn: {
              label: 'MXN',
              description: 'Peso mexicano',
            },
            brl: {
              label: 'BRL',
              description: 'Real brasileiro',
            },
            php: {
              label: 'PHP',
              description: 'Peso filipino',
            },
            inr: {
              label: 'INR',
              description: 'Rupia indiana',
            },
            gbp: {
              label: 'GBP',
              description: 'Libra esterlina',
            },
            cad: {
              label: 'CAD',
              description: 'Dólar canadense',
            },
            cop: {
              label: 'COP',
              description: 'Peso colombiano',
            },
            thb: {
              label: 'THB',
              description: 'Baht tailandês',
            },
            vnd: {
              label: 'VND',
              description: 'Dong vietnamita',
            },
            sgd: {
              label: 'SGD',
              description: 'Dólar de Singapura',
            },
            idr: {
              label: 'IDR',
              description: 'Rupia indonésia',
            },
          },
          verificationPending: {
            title: 'Verificação Pendente',
            description:
              'Estamos verificando sua conta. Por isso, você não tem acesso a nenhuma das nossas moedas suportadas neste momento.',
            cta: 'Contatar Suporte',
          },
        },
        methods: {
          title: 'Selecione um método de saque',
          options: {
            usd: {
              ach: {
                title: 'ACH',
                subtitle: 'Transferência para conta bancária dos EUA',
                description:
                  'Adequado para pagamentos diários ou transferências recorrentes dentro dos EUA.',
                badges: {
                  recommended: 'Recomendado',
                  domestic: 'Nacional',
                  businessDays01: '0-1 dias úteis',
                  noFees: 'Sem taxas',
                },
              },
              wire: {
                title: 'WIRE',
                subtitle: 'Transferência para conta bancária dos EUA',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 dias úteis',
                  domestic: 'Nacional',
                  businessDays01: '0-1 dias úteis',
                },
              },
              swift: {
                title: 'Swift',
                subtitle: 'Transferência para conta bancária dos EUA',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  comingSoon: 'Em breve',
                  international: 'Internacional',
                  businessDays05: '0-5 dias úteis',
                },
              },
            },
            eur: {
              sepa: {
                title: 'SEPA',
                subtitle: 'Transferência de conta bancária da UE',
                description:
                  'Converta moedas digitais e receba EUR em uma conta bancária.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: 'Sem taxas',
                },
              },
              wire: {
                title: 'WIRE',
                subtitle: 'Transferência para conta bancária da UE',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 dias',
                  domestic: 'Nacional',
                  businessDays01: '0-1 dias',
                },
              },
              swift: {
                title: 'Swift',
                subtitle: 'Transferência para conta bancária dos EUA',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  comingSoon: 'Em breve',
                  international: 'Internacional',
                  businessDays05: '0-5 dias úteis',
                },
              },
            },
            mxn: {
              spei: {
                title: 'SPEI',
                subtitle: 'Transferência de conta bancária MX',
                description:
                  'Converta moedas digitais e receba MXN em uma conta bancária.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: 'Sem taxas',
                },
              },
            },
            brl: {
              pix: {
                title: 'PIX',
                subtitle: 'Transferência de conta bancária BR',
                description:
                  'Converta moedas digitais e receba BRL em uma conta bancária.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: 'Sem taxas',
                },
              },
              wire: {
                title: 'Wire',
                subtitle: 'Transferência para conta bancária BR',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 dias',
                },
              },
            },
            php: {
              instapay: {
                title: 'Instapay',
                subtitle: 'Transferência de conta bancária PH',
                description:
                  'Converta moedas digitais e receba PHP em uma conta bancária.',
                badges: {
                  amountsSmallerThan50000: 'Montantes < 50,000 PHP',
                },
              },
              swiftpay_pesonet: {
                title: 'Swiftpay PesoNet',
                subtitle: 'Transferência para conta bancária PH',
                description:
                  'Converta moedas digitais e receba PHP em uma conta bancária.',
                badges: {
                  amountsBiggerOrEqualTo50000: 'Montantes ≥ 50,000 PHP',
                },
              },
            },
            inr: {
              neft: {
                title: 'NEFT',
                subtitle: 'Transferência de conta bancária IN',
                description:
                  'Converta moedas digitais e receba INR em uma conta bancária.',
                badges: {
                  recommended: 'Recomendado',
                  instant: 'Instantâneo',
                  noFees: 'Sem taxas',
                },
              },
              wire: {
                title: 'Wire',
                subtitle: 'Transferência para conta bancária INR',
                description:
                  'Adequado para transferências grandes ou internacionais.',
                badges: {
                  international: 'Internacional',
                  businessDays02: '0-2 dias',
                },
              },
            },
            gbp: {
              fps: {
                title: 'FPS',
                subtitle: 'Transferência para conta bancária GBP',
                description:
                  'Converte moedas digitais e recebe GBP em uma conta bancária.',
              },
            },
            cad: {
              eft: {
                title: 'EFT',
                subtitle: 'Transferência para conta bancária CAD',
                description:
                  'Converte moedas digitais e recebe CAD em uma conta bancária.',
              },
            },
            cop: {
              pse: {
                title: 'PSE',
                subtitle: 'Transferência para conta bancária COP',
                description:
                  'Converte moedas digitais e recebe COP em uma conta bancária.',
              },
            },
            thb: {
              bank_transfer: {
                title: 'Transferência Bancária',
                subtitle: 'Transferência para conta bancária THB',
                description:
                  'Converte moedas digitais e recebe THB em uma conta bancária.',
              },
            },
            vnd: {
              bank_transfer: {
                title: 'Transferência Bancária',
                subtitle: 'Transferência para conta bancária VND',
                description:
                  'Converte moedas digitais e recebe VND em uma conta bancária.',
              },
            },
            sgd: {
              fast: {
                title: 'FAST',
                subtitle: 'Transferência para conta bancária SGD',
                description:
                  'Converte moedas digitais e recebe SGD em uma conta bancária.',
              },
            },
            idr: {
              bank_transfer: {
                title: 'Transferência Bancária',
                subtitle: 'Transferência para conta bancária IDR',
                description:
                  'Converte moedas digitais e recebe IDR em uma conta bancária.',
              },
            },
          },
        },
        blocked: {
          title: 'Off-ramping bloqueado',
          description:
            'Você não está autorizado a off-ramp qualquer moeda. Por favor, entre em contato com o suporte se precisar de assistência.',
          cta: 'Contatar Suporte',
        },
      },
      selectors: {
        wallet: {
          title: 'Selecionar Carteira',
          drawerTitle: 'Carteiras',
          network: 'Selecionar Rede da Carteira',
          confirm: 'Confirmar Carteira',
          walletHistory: 'Histórico de Carteiras',
          addressInputPlaceholder: 'Colar endereço da carteira',
          confirmAddressInputButton: 'Usar endereço',
          multisigSupportBadge: 'Suporte para múltiplas assinaturas',
        },
        card: {
          title: 'Selecionar Cartão',
          drawerTitle: 'Cartões',
        },
        bankAccount: {
          title: 'Selecionar Conta Bancária',
          drawerTitle: 'Contas Bancárias',
          emptyTitle: 'Nenhuma conta bancária {{currency}} encontrada',
        },
      },
      form: {
        youPay: 'Você paga',
        youReceive: 'Você recebe',
        inputEditingTooltip:
          'Atualizaremos automaticamente este valor assim que você terminar de editar.',
        maxTransactionSize: 'Tamanho máximo da transação',
        amountAdjustments: 'Detalhamento de Taxas',
        additionalDetails: {
          title: 'Detalhes adicionais',
          wireMessage: {
            checkbox: 'Adicionar uma mensagem de transferência',
            textareaLabel: 'Descrição',
            info: 'Esta mensagem será visível para o destinatário da transferência. Máximo de caracteres: 105',
          },
          ffc: {
            checkbox: 'Para crédito adicional (FFC)',
            textareaLabel: 'Referência do wire',
            textareaPlaceholder: 'Nome, 0000-0000',
          },
        },
        cta: {
          selectAWalletFirst: 'Selecione uma carteira primeiro',
          selectACardFirst: 'Selecione um cartão primeiro',
          selectABankAccountFirst: 'Selecione uma conta bancária primeiro',
          create: 'Criar transferência',
          getInstructions: 'Obter instruções',
        },
        walletBalance: {
          label: 'Saldo da carteira:',
          actions: {
            max: 'Máximo',
            half: 'Metade',
          },
        },
        errors: {
          walletNotSupported: {
            title: 'Carteira não suportada',
            description:
              'Este tipo de transferência não suporta a carteira selecionada.',
          },
          verifyCurrencyPair: 'Par de moedas não suportado nesta rede',
          verifyAmounts: {
            source: {
              min: 'O valor da fonte é menor que o mínimo',
              max: 'O valor da fonte é maior que o máximo',
            },
            destination: {
              min: 'O valor de destino é menor que o mínimo',
              max: 'O valor de destino é maior que o máximo',
            },
          },
        },
      },
      onRampInstructions: {
        title: 'Instruções de transferência',
        consent: {
          title: 'Por favor, confirme',
          description:
            'Eu transferi o valor correto da minha conta bancária para a conta indicada via {{transferMethod}} usando os dados fornecidos acima.',
        },
        transferMethodAlert: {
          title: 'Somente transferência {{transferMethod}}',
          description:
            'Por favor, não envie fundos por {{alternativeTransferMethod1}} ou {{alternativeTransferMethod2}}. A transferência precisa ser feita usando {{transferMethod}}. Certifique-se de que todos os dados estão corretos.',
        },
      },
      tooltips: {
        sepa: 'Para acessar pagamentos SEPA, você deve concluir o processo de KYC e fornecer prova de endereço. Se você completou o KYC sem enviar a prova de endereço, entre em contato com seu comerciante para continuar.',
        isAboveLimit:
          'O valor inserido excede o tamanho máximo da transação de ${maxSingleTxSizeFormatted}',
        currencies: 'Esta moeda não está disponível para sua conta',
      },
    },
    myPayouts: {
      title: 'Histórico de Transferências',
      table: {
        header: {
          type: 'Tipo',
          source: 'Origem',
          destination: 'Destino',
          amountSent: 'Enviado',
          amountReceived: 'Recebido',
          status: 'Status',
          actions: 'Ações',
          date: 'Data',
        },
      },
      onRamps: {
        tabTitle: 'On-ramps',
        empty: {
          title: 'Nenhuma transferência on-ramp encontrada',
          description:
            'Com {{merchantName}}, você pode realizar transferências de on- e off-ramp para exchanges, carteiras e bancos de forma transparente. Converta sua moeda digital em moeda fiat e vice-versa.',
          action: 'Criar transferência',
        },
      },
      offRamps: {
        tabTitle: 'Off-ramps',
        empty: {
          title: 'Nenhuma transferência off-ramp encontrada',
          description:
            'Com {{merchantName}}, você pode realizar transferências de on- e off-ramp para exchanges, carteiras e bancos de forma transparente. Converta sua moeda digital em moeda fiat e vice-versa.',
          action: 'Criar transferência',
        },
      },
      history: {
        tabTitle: 'Histórico',
        empty: {
          title: 'Nenhuma transferência encontrada',
          description:
            'Com {{merchantName}}, você pode realizar transferências de on- e off-ramp para exchanges, carteiras e bancos de forma transparente. Converta sua moeda digital em moeda fiat e vice-versa.',
          action: 'Criar transferência',
        },
      },
      detail: {
        id: 'ID',
        type: {
          onRamp: 'On-ramp',
          offRamp: 'Off-ramp',
          onChain: 'On-chain',
        },
        fiatNetwork: {
          wire: 'Transferência bancária',
          ach: 'Transferência ACH',
          sepa: 'Transferência SEPA',
        },
        info: {
          created: 'Criado',
          paymentMethod: 'Método de pagamento',
          email: 'Email',
        },
        payment: {
          title: 'Detalhes do pagamento',
          amount: 'Quantia',
          type: 'Tipo',
          from: 'De',
          to: 'Para',
          summary: 'Resumo',
          fees: 'Taxas',
        },
        bank: {
          title: 'Detalhes do banco',
          name: 'Nome do banco',
          accountType: 'Tipo de conta',
          bankName: 'Nome do banco',
          beneficiaryName: 'Nome do beneficiário',
          bankAddress: 'Endereço do banco',
          beneficiaryAddress: 'Endereço do beneficiário',
          accountNumber: 'Número da conta',
          routingNumber: 'Número do banco',
        },
        instructions: {
          title: 'Instruções de transferência',
          amountToSend: 'Quantia a enviar',
          message: {
            ach: 'Mensagem de transferência ACH',
            wire: 'Mensagem de transferência bancária',
          },
        },
        cancelCta: 'Cancelar transferência',
        cancellationWarning: {
          title: 'Verifique antes de confirmar',
          description:
            'Confirme apenas se você não transferiu nenhum {{currency}} para o endereço <0>{{address}}</0> na blockchain {{blockchain}}. Caso contrário, pode resultar em perda de fundos.',
          cta: 'Confirmar cancelamento',
        },
        onRampReminder: {
          title: 'O processo de on-ramp na Sphere é manual.',
          description:
            'Caso ainda não tenha enviado, por favor, <0>faça uma transferência {{transferMethod}} da sua conta para a Sphere com os dados abaixo</0>. Nós te notificaremos por e-mail assim que a transferência for concluída.',
        },
      },
    },
    tos: {
      alreadyAcceptedCtaText: 'Voltar',
      successCtaText: 'Continuar',
    },
    languageSelector: {
      label: 'Alterar idioma',
    },
    tables: {
      showing: 'Mostrando {{from}}-{{to}} de {{total}} resultados',
      previous: 'Anterior',
      next: 'Próximo',
    },
    badges: {
      bankAccount: {
        pending: {
          text: 'Pendente',
          description:
            'A conta bancária está sendo verificada, esse processo geralmente leva de alguns segundos a um minuto. Contas bancárias pendentes não podem ser usadas para transferências.',
        },
        active: {
          text: 'Ativa',
          description:
            'A conta bancária está ativa e pronta para ser usada para transferências.',
        },
        inactive: {
          text: 'Deletada',
          description: 'A conta bancária foi deletada.',
        },
        invalid: {
          text: 'Inválida',
          description: 'A conta bancária é inválida.',
        },
      },
      payout: {
        pending: {
          text: 'Pendente',
          description: 'A transferência está pendente de aprovação.',
        },
        funded: {
          text: 'Financiado',
          description: 'A transferência foi financiada.',
        },
        refunded: {
          text: 'Reembolsado',
          description: 'A transferência foi reembolsada.',
        },
        processing: {
          text: 'Em processamento',
          description: 'A transferência está atualmente em processamento.',
        },
        succeeded: {
          text: 'Sucesso',
          description: 'A transferência foi completada com sucesso.',
        },
        failed: {
          text: 'Falhou',
          description: 'A transferência falhou.',
        },
        failedPrecondition: {
          text: 'Falhou',
          description: 'A transferência falhou.',
        },
        cancelled: {
          text: 'Cancelado',
          description: 'A transferência foi cancelada.',
        },
      },
      kyc: {
        approved: {
          text: 'Verificado',
        },
        rejected: {
          text: 'Rejeitado',
        },
        incomplete: {
          text: 'Incompleto',
        },
        pending: {
          text: 'Pendente',
        },
        additionalReviewRequired: {
          text: 'Revisão adicional necessária',
        },
      },
      sepa: {
        approved: {
          text: 'Ativo',
        },
        incomplete: {
          text: 'Inativo',
        },
      },
    },
    notifications: {
      otpEmailResent: {
        title: 'Email enviado',
        description: 'Verifique seu email para o código de verificação',
      },
      otpEmailResentError: {
        title: 'Algo deu errado',
        description:
          'Não conseguimos reenviar o código de verificação no momento. Por favor, tente novamente mais tarde.',
      },
      signInSuccess: {
        title: 'Email verificado',
        description: 'Você está agora conectado ao Ramp',
      },
      kycDone: {
        title: 'Verificação de identidade completa',
        description:
          'Sua verificação de identidade foi completada/está em revisão.',
      },
      bankAccountDeleteSuccess: {
        title: 'Conta bancária deletada',
        description: 'Sua conta bancária foi deletada.',
      },
      bankAccountDeleteError: {
        title: 'Algo deu errado',
        description:
          'Não conseguimos deletar sua conta bancária no momento. ({{error}})',
      },
      payouts: {
        create: {
          success: {
            title: 'Transferência iniciada',
            onRampDescription: 'Sua transfêrncia de {{type}} foi iniciada.',
            offRampDescription: 'Sua transfêrncia de {{type}} foi iniciada.',
          },
          error: {
            title: 'Algo deu errado',
            description:
              'Não conseguimos criar sua transferência de {{type}} no momento. ({{error}})',
          },
        },
      },
    },
    settings: {
      title: 'Configurações',
      loginEmail: {
        label: 'Email de login',
        description:
          'Email vinculado à sua conta RAMP. Este dado não pode ser modificado.',
      },
      kyc: {
        title: 'Meu KYC/B',
        cta: 'Reenviar',
      },
      sepa: {
        title: 'Transferências SEPA',
        description: {
          incomplete:
            'Esta conta foi verificada antes da adição das transferências SEPA, que requerem comprovação de endereço para acesso. Por favor, envie novamente seus documentos KYC para obter acesso às transferências SEPA.',
        },
        cta: 'Reenviar',
      },
      customerId: 'ID do cliente',
      form: {
        name: 'Nome',
        phone: 'Número de telefone',
        cta: 'Salvar alterações',
      },
    },
    translations: {
      amountAdjustmentType: {
        networkFee: 'Taxa da rede',
        sphereConversionFee: 'Taxa da aplicação de conversão',
        sphereFixedFee: 'Taxa da aplicação fixa',
        merchantConversionFee: 'Taxa do mercador de conversão',
        merchantFixedFee: 'Taxa do mercador fixa',
        conversionFee: 'Taxa de conversão',
        fxRate: 'Taxa de câmbio',
        noFxRateMessage: '',
        sponsoredFee: 'Quantia patrocinada',
        totalFee: 'Total',
        pay: 'Você paga',
        receive: 'Você recebe',
      },
      fees: 'Taxas',
    },
    apiErrors: {
      'application/invalid-id': 'ID da Aplicação inválido.',
      'application/not-found': 'Aplicação não encontrada.',
      'ramp/auth/bad-host': 'Ramp não está configurado para este comerciante.',
      'ramp/auth/host-access': 'Os comerciantes não podem autenticar.',
      'wallets/duplicate': 'A carteira já existe.',
      'wallets/invalid-address': 'Endereço de carteira inválido.',
      'wallets/not-found': 'Carteira não encontrada.',
      'wallets/unsafe-address': 'Não é possível interagir com esta carteira.',
      'wallets/unsupported-network': 'Rede não suportada.',
      unknown: 'Algo deu errado.',
    },
    apply: 'Aplicar',
    continue: 'Continuar',
    back: 'Voltar',
    backToSphere: 'Voltar para Ramp',
    cancel: 'Cancelar',
    comingSoon: 'Em breve',
    collapse: 'Recolher',
    expand: 'Expandir',
    export: 'Exportar',
    filter: 'Filtrar',
    copied: 'Copiado!',
    selected: 'Selecionado',
    poweredBy: 'powered by',
    signOut: 'Sair',
    deleted: 'Deletado',
    type: 'Tipo',
    network: 'Rede',
    status: 'Status',
    reset: 'Redefinir',
  },
} as const satisfies LocaleResource;

export default pt;
